import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DocumentUploadModal } from "@/components/document-upload-modal"
import { useDocumentsUpload } from "../../-components/use-documents-upload"
import { uploadVisibility } from "../../-lib/search"

export const Route = createFileRoute("/_layout/documents/_list/upload")({
  component: UploadDocumentModalRoute,
})

function UploadDocumentModalRoute(): React.ReactElement {
  const navigate = useNavigate()
  const { tab = "user" } = Route.useSearch()
  const { uploadFile, isUploading, canUpload } = useDocumentsUpload(
    uploadVisibility(tab),
  )

  return (
    <DocumentUploadModal
      open
      onOpenChange={(open) => {
        if (!open) {
          navigate({ to: "/documents", search: true })
        }
      }}
      onUpload={async (file) => {
        if (!canUpload) {
          return
        }
        await uploadFile(file)
        navigate({ to: "/documents", search: true })
      }}
      isUploading={isUploading}
    />
  )
}
